import { render, staticRenderFns } from "./pay2.vue?vue&type=template&id=28eefb66&scoped=true"
import script from "./pay2.vue?vue&type=script&lang=js"
export * from "./pay2.vue?vue&type=script&lang=js"
import style0 from "./pay2.vue?vue&type=style&index=0&id=28eefb66&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28eefb66",
  null
  
)

export default component.exports